var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkout-successfully d-flex justify-content-center align-items-center flex-column"},[_c('img',{staticClass:"checkout-img-successfully",attrs:{"src":_vm.icoCheckMarkSuccess,"alt":"successfully"}}),_c('h3',{staticClass:"h3 font-bold mb-2 text-center mt-4"},[_vm._v(" ¡Pago completado! ")])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }